import type { Action } from 'redux';
import dash_api from '../../../../main/support/dash_api';
import type { IAdLinkResponse } from '../../../../main/types/links';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

export const GetAdLinksAsyncAction = new ReduxAsyncAction<'AD_LINKS_GET_AD_LINKS', void, IAdLinkResponse[]>(
  'AD_LINKS_GET_AD_LINKS'
);

export const GET_AD_LINKS_ACTION_CONSTANTS = GetAdLinksAsyncAction.actionNamespaceConstants;

GetAdLinksAsyncAction.registerRequest(async () => {
  const { data } = await dash_api.get<IAdLinkResponse[]>(`/v1/link-creator/ads`);
  return data;
});

export const getAdLinks = GetAdLinksAsyncAction.request;

export type GetAdLinksResponseAction = Action<typeof GET_AD_LINKS_ACTION_CONSTANTS.response> & { data: IAdLinkResponse[] };
